import { Routes } from '@angular/router';
import { AdminLayoutComponent } from './shared/components/layouts/admin-layout/admin-layout.component';
import { AuthLayoutComponent } from './shared/components/layouts/auth-layout/auth-layout.component';
import { AuthGuard } from './shared/services/auth/auth.guard';

export const rootRouterConfig: Routes = [
    {
        path: '',
        redirectTo: 'dashboard',
        pathMatch: 'full'
    },
    {
        path: '',
        component: AuthLayoutComponent,
        children: [
            {
                path: 'sessions',
                loadChildren: './views/sessions/sessions.module#SessionsModule',
                data: { title: 'Session' }
            }
        ]
    },
    {
        path: '',
        component: AdminLayoutComponent,
        canActivate: [AuthGuard],
        children: [
            {
                path: 'dashboard',
                loadChildren:
                    './views/dashboard/dashboard.module#DashboardModule',
                data: { title: 'Dashboard', breadcrumb: 'Dashboard' }
            },
            {
                path: 'rentals',
                loadChildren: './views/rentals/rentals.module#RentalsModule',
                data: { title: 'Rentals', breadcrumb: 'Rentals' }
            },
            {
                path: 'leases',
                loadChildren: './views/leases/leases.module#LeasesModule',
                data: { title: 'Leases', breadcrumb: 'Leases' }
            },
            {
                path: 'lease/:lease_id',
                loadChildren: './views/leases/lease/lease.module#LeaseModule',
                data: { title: 'Lease', breadcrumb: 'Lease' }
            },
            {
                path: 'maintenance',
                loadChildren:
                    './views/maintenance/maintenance.module#MaintenanceModule',
                data: { title: 'Maintenance', breadcrumb: 'Maintenance' }
            },
            {
                path: 'accounting',
                loadChildren:
                    './views/accounting/accounting.module#AccountingModule',
                data: { title: 'Accounting', breadcrumb: 'Accounting' }
            },
            {
                path: 'reports',
                loadChildren: './views/reports/reports.module#ReportsModule',
                data: { title: 'Reports', breadcrumb: 'Reports' }
            }
        ]
    },
    {
        path: '',
        component: AdminLayoutComponent,
        canActivate: [AuthGuard],
        children: [
            {
                path: 'settings',
                loadChildren: './settings/settings.module#SettingsModule',
                data: { title: 'Settings', breadcrumb: 'Settings' }
            }
        ]
    },
    {
        path: 'generate',
        children: [
            {
                path: 'pdf',
                loadChildren: './shared/pdf/pdf.module#PdfModule',
                data: { title: 'Generate PDF', breadcrumb: 'PDF' }
            }
        ]
    },
    {
        path: '**',
        redirectTo: 'sessions/404'
    }
];
